export default "__VITE_ASSET__V2r0qt1x__"